// A PCR tracking number is the CMS RCD Unique Tracking Number: 14 letters or
// numbers. Keep only A-Z and 0-9 and uppercase the letters.
export const sanitizePcrNumber = (value: string): string =>
  value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
